<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="项目单位：" prop="pid">
                {{pnames[0]}}
            </el-form-item>
            <el-form-item label="单位工程：">
                {{pnames[1]}}
            </el-form-item>
            <el-form-item label="分部工程：">
                {{pnames[2]}}
            </el-form-item>
            <el-form-item label="单元工程：">
                {{pnames[3]}}
            </el-form-item>
            <el-form-item label="单元编号：" prop="unit_code">
                <span>{{model.unit_code}}</span>
            </el-form-item>
            <el-form-item label="孔号：" prop="hole_code">
                <span>{{model.hole_code}}</span>
            </el-form-item>
            <el-form-item label="孔序：" prop="hole_order">
                <span>{{model.hole_order}}</span>
            </el-form-item>
            <el-form-item label="桩号：" prop="pile_no">
                <span>{{model.pile_no}}</span>
            </el-form-item>
            <el-form-item label="排序：" prop="sort">
                <span>{{model.sort}}</span>
            </el-form-item>
            <el-form-item label="孔斜：" prop="oblique">
                <span>{{model.oblique}}</span>
            </el-form-item>
            <el-form-item label="起始高程：" prop="elevation_start">
                <span>{{model.elevation_start}}</span>
            </el-form-item>
            <el-form-item label="结束高程：" prop="elevation_end">
                <span>{{model.elevation_end}}</span>
            </el-form-item>
            <el-form-item label="孔深：" prop="deep">
                <span>{{model.deep}}</span>
            </el-form-item>
            <el-form-item label="实际孔深：" prop="deep_real">
                <span>{{model.deep_real}}</span>
            </el-form-item>
            <el-form-item label="灌浆类型：" prop="grout_type">
                <span>{{ transEnu(model.grout_type, "grout_type") }}</span>
            </el-form-item>
            <el-form-item label="先导孔：" prop="is_pilot">
                <span>{{ transEnu(model.is_pilot, "yesNo") }}</span>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <span>{{model.remark}}</span>
            </el-form-item>
            <el-form-item label="顺序：" prop="order_index">
                <span>{{model.order_index}}</span>
            </el-form-item>
            <el-form-item label="添加人：" prop="creator_name">
                <span>{{model.creator_name}}</span>
            </el-form-item>
            <el-form-item label="添加时间：" prop="create_time">
                <span>{{model.create_time}}</span>
            </el-form-item>
            <el-form-item label="更新人：" prop="update_name">
                <span>{{model.update_name}}</span>
            </el-form-item>
            <el-form-item label="更新时间：" prop="update_time">
                <span>{{model.update_time}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { getModelById } from '@/api/common'
import { getProjectDivisionParentNames } from '@/api/org'

export default {
    name: 'workHoleInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                pid1: '',
                pid2: '',
                pid3: '',
                pid4: '',
                unit_code: '',
                unit_name: '',
                hole_code: '',
                hole_order: '',
                grout_type: '',
                is_pilot: '',
                remark: '',
                order_index: '',
                creator_id: '',
                creator_name: '',
                create_time: '',
                update_id: '',
                update_name: '',
                update_time: '',
            },
            getObj:{
                url:'/api/admin/workhole/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['grout_type'],
            pnames: [],
        };
    },
    methods: {
        getModelData() {
            this.model = this.copyObj(this.init_model);
            if (this.id > 0) {
                this.getObj.data.value = this.id;
                getModelById(this.getObj).then(res => {
                    if (res.code === 1) {
                        this.model = res.data;
                        if (this.exits_p_name != '') {
                            this.old_check = this.model[this.exits_p_name];
                        }
                        getProjectDivisionParentNames(this.model.pid4).then(res=>{
                            if(res.code ==1){
                                this.pnames = res.data
                            }
                        })
                        this.formateData();
                    } else {
                        this.$msg(res.msg)
                        this.closeDialog()
                    }
                })
            }
        },
    }
};
</script>